import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propStr, propNumber, propChildren, } from '../../../../../helpers/custom-prop-types';
import Image from '../../../../Ui/Common/Image';
const ProffitSearchLandingPageStep = (props) => {
    const { alt, description, image, step, title } = props;
    return (_jsxs("div", Object.assign({ className: 'proffit_search_landing_page_step' }, { children: [_jsxs("div", Object.assign({ className: 'step_left' }, { children: [_jsx("div", Object.assign({ className: 'left_number' }, { children: _jsx("span", { children: `Step${step}` }) })), _jsx("h5", Object.assign({ className: 'left_title' }, { children: title })), _jsx("div", Object.assign({ className: 'left_description' }, { children: description }))] })), _jsx("div", Object.assign({ className: 'step_right' }, { children: _jsx(Image, { alt: alt, className: 'right_image', src: image, useImage: true }) }))] })));
};
ProffitSearchLandingPageStep.propTypes = {
    alt: propStr().isRequired,
    description: propChildren().isRequired,
    image: propStr().isRequired,
    step: propNumber().isRequired,
    title: propChildren().isRequired,
};
export default ProffitSearchLandingPageStep;
